import { defineModal, Modal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { useMemoSelector } from '@spa/redux/hooks'
import type { FC } from 'react'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCurrentAccount } from 'snap-redux/modules/accounts/selectors'

import { entitiesActions } from '../../redux/modules/entities'
import { membershipsSelectors } from '../../redux/selectors'

import SortEmployeesForm from './MembershipSortForm'

type SortEmployeeModalProps = {
  teamId: number
}

export const sortEmployeeModalDef = defineModal<SortEmployeeModalProps>({
  name: 'sortEmployeeModal'
})

const SortEmployeeModal: FC = () => {
  const { close, isOpen, data } = sortEmployeeModalDef.useModal()
  const { t } = usePlanningFormTranslation()
  const dispatch = useDispatch()
  const account = useMemoSelector(getCurrentAccount)
  const membershipsOfTeam = useMemoSelector(state =>
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    membershipsSelectors.getMembershipsByTeamId(state, { teamId: data.teamId })
  ).filter(member => member.include_owner_in_schedules)

  useEffect(() => {
    /**
     * We reset planning data on modal close to prevent
     * uneccessary re-fetch resulting in better performance
     */
    return () => {
      dispatch(entitiesActions.getMemberships())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal variant='right' opened={isOpen} onClose={close}>
      <>
        <Modal.Header title={t('sortEmployeesForm.title')} />

        <SortEmployeesForm
          // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
          teamId={data.teamId}
          account={account}
          closeModal={close}
          membershipsOfTeam={membershipsOfTeam}
        />
      </>
    </Modal>
  )
}

export default sortEmployeeModalDef.withModalShow(SortEmployeeModal)
